<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info navadno-besedilo">
          Podatke o naročninah in priključkih ter pregled naročenih storitev boste našli na strani
          <a href="/Mojprofil/Narocnine" class="krepko">
            Naročnine.
          </a>
        </p>
      </div>
    </div>
    <div style="clear: both"/>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaNastavitveMojT2'
}
</script>
<style scoped>
.info-okvir {
  width: 650px;
  height: 85px;
  display: flex;
}

.krepko {
  color: #409eff !important;
  font-weight: bold;
}

@media only screen and (max-width: 1100px) {
  .postavitev-info-icone {
    padding-bottom: 0;
  }

  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/NastavitveMojT2/InfoKomponentaNastavitveMojT2.vue